import React from "react";
import { Box, Typography } from "@mui/material";

interface MyTimesheetMyRequestsDashboardSummaryProps {
  label: string;
  value: string | number;
}

export const MyTimesheetMyRequestsDashboardSummary = ({
  label,
  value,
}: MyTimesheetMyRequestsDashboardSummaryProps) => {
  return (
    <Box
      style={{
        padding: "12px 16px",
        borderRadius: "8px",
        backgroundColor: "#919699",
      }}
    >
      <Typography variant="body1" style={{ color: "#fff" }}>
        {label}
      </Typography>
      <Typography variant="h4" style={{ color: "#fff" }}>
        {value}
      </Typography>
    </Box>
  );
};

export default MyTimesheetMyRequestsDashboardSummary;
